import './Extra.css';

function LetterToReader() {
  return (
    <div className="LetterToReader">
      <h3>Dear Reader,</h3>
      <p>
      Thank you for reading through <i>Location Mythos!</i></p>
      <p>
      What a journey it has been to write this piece. I began with wanting the piece to be a “myth” 
      based on my own life and experiences in each location that I had lived in (hence the name of the piece). 
      An easy start with San Francisco, my mom used to tell me when I was growing up that I was a mermaid and 
      that she and my dad had adopted me from my merpeople parents! However, as the piece progressed and followed 
      the major places I grew up in, I began to notice a desire to write about my childhood best friend, and from 
      there, the idea to write a distant retelling of the Myth of Cyane and Persephone came to light. 
      You can read more about the myth <a href="https://en.wikipedia.org/wiki/Cyane">here</a>.
      </p>
      <p>
      As an avid reader of a lot of Greek and Norse mythology, it only seemed right to try and recreate my own 
      myth using parts of other myths, (the beginning is a revision of <a 
      href="https://www.vatican.va/archive/bible/genesis/documents/bible_genesis_en.html#:~:text=The%20Book%20of%20Genesis&text=%5B1%3A1%5D%20In%20the,%22%3B%20and%20there%20was%20light."
      target="_blank"
      >Genesis</a>, and Incline’s <a href="https://www.diamondpeak.com/event/ullr-fest/" target="_blank">Uller Fest</a> is real, 
      however, I wanted to highlight more the <a href="https://en.wikipedia.org/wiki/Ullr" target="_blank">god</a> rather than the beer).
      </p>
      <p>
      I also hoped to encapsulate the feeling of growing up with a best friend who you have a deep love for, not necessarily 
      in the relationship sense but in the ancient Greek "<a 
      href="https://www.yesmagazine.org/health-happiness/2013/12/28/the-ancient-greeks-6-words-for-love-and-why-knowing-them-can-change-your-life" target="_blank">Philia</a>" sense. 
      And the feeling of when they inevitably move away.
      (Try listening to the beat of the <a href="https://www.youtube.com/watch?v=ZESulOPdnck">Grand Pas de Deux</a> between the Sugar Plum Fairy and the Prince and compare the heartbeat!).
      The magic and wonder and elasticity of time growing up, but how the world gets more rigid, smaller, less fantastic as 
      you grow older. Yet still, there are those small pockets of magic in adult life, like the spell cast by the moon rising over a snowstorm.
      </p>
      <a>Again, thank you for reading, and encouraging you to find your own personal magic.</a>
      <h3>-BQW</h3>
    </div>
  );
}

export default LetterToReader;